import { getJsonParamsForWindow } from 'meta/features/json-params';
class WebEvents {
    run(win, callback) {
        let events = getJsonParamsForWindow(win).WebEvents;
        for (var e in events) {
            // run callback for specific web event
            callback({ type: e, data: Object.assign({ _frameSession: win.frameSession }, events[e]) });
        }
    }
}
let instance = new WebEvents();
export default instance;
